module.exports = __webpack_public_path__ + "static/img/11.b8ccd9f.png";


//////////////////
// WEBPACK FOOTER
// ./static/images/products/1/1/2/zh/11.png
// module id = DP5S
// module chunks = 0